import React, { Component } from 'react';
import { Tab } from 'semantic-ui-react';

import ReturnInvoices from './ReturnInvoices';
import CanceledReturnInvoicesContainer from './CanceledReturnInvoices';

class ReturnInvoicesTabs extends Component {
  render() {
    const panes = [
      {
        menuItem: 'Return Invoices',
        render: () => (
          <Tab.Pane>
            {' '}
            <ReturnInvoices />
          </Tab.Pane>
        ),
      },
      {
        menuItem: 'Canceled Return Invoices',
        render: () => (
          <Tab.Pane>
            <CanceledReturnInvoicesContainer />
          </Tab.Pane>
        ),
      },
    ];

    return (
      <div>
        {' '}
        <Tab panes={panes} />
      </div>
    );
  }
}

export default ReturnInvoicesTabs;
